var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fillInBox"},[(_vm.type != 3)?_c('one-fill-in',{attrs:{"id":_vm.id,"numId":_vm.numId}}):_c('two-fill-in',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }